// @flow

import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { selectUserCountryCode } from '@gandi/authentication';
import { useCountries } from '@gandi/react-places';

import { Select, type Props as FieldProps } from 'src/Reshaped/Form/Select';
import { useAppSelector } from 'src/hooks/useAppSelector';

type Props = {
  ...Partial<FieldProps>,
  name: string,
  /** WARN not implemented */
  // eslint-disable-next-line react/no-unused-prop-types
  readOnly?: boolean,
  placeholder?: string,
};

export function CountrySelect({
  onChange,
  disabled,
  control,
  loading,
  help,
  name,
  placeholder,
  rules,
  label,
}: Props): React.MixedElement {
  const form = useFormContext();

  const { setValue } = form;
  const countryFieldValue = form.watch('country');

  const defaultCountry = useAppSelector(selectUserCountryCode);

  const { userCountries, isLoadedCountries } = useCountries(
    defaultCountry,
    true,
    countryFieldValue,
  );

  const options = userCountries.map(country => ({
    label: country.name,
    value: country.alpha2,
  }));

  // Update to first render when we don't have a countryFieldValue with the defaultValue and add dirty
  useEffect(() => {
    if (defaultCountry && isLoadedCountries && !countryFieldValue) {
      setValue(name, defaultCountry, { shouldDirty: true });
    }
  }, [countryFieldValue, defaultCountry, isLoadedCountries, name, setValue]);

  return (
    <Select
      name={name}
      label={label}
      options={options}
      onChange={e => {
        // update the form field
        setValue(name, e.value);
        form.resetField('state');
        // update the parent for chain changes
        if (typeof onChange === 'function') onChange(e);
      }}
      disabled={disabled || loading || !isLoadedCountries}
      // TODO: How to represent the loading state (reshaped)
      // isLoading={loading}
      placeholder={placeholder}
      control={control}
      rules={rules}
      help={help}
    />
  );
}
